(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["asma-product-funnel"] && !Shopify.designMode) return;
  try {
    (() => {
    const initAsmaFunnel = (root) => {
      if (root.dataset.asmaFunnelReady === 'true') {
        return;
      }

      const form = document.getElementById(root.dataset.formId);
      const sticky = root.querySelector('[data-asma-funnel-sticky]');
      const stickyButton = root.querySelector('[data-asma-funnel-sticky-submit]');

      if (!form || !sticky || !stickyButton) {
        return;
      }

      const submitButton = form.querySelector('[type="submit"]');

      if (!submitButton) {
        return;
      }

      root.dataset.asmaFunnelReady = 'true';

      const track = (eventName) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: eventName,
          asma_product_id: root.dataset.productId,
          asma_product_title: root.dataset.productTitle
        });
      };

      const isDisabled = () =>
        submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true';

      const syncButton = () => {
        stickyButton.disabled = isDisabled();
      };

      const setStickyVisibility = (primaryButtonVisible) => {
        const shouldHide = primaryButtonVisible || isDisabled();
        sticky.hidden = shouldHide;
        sticky.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      };

      stickyButton.addEventListener('click', () => {
        if (isDisabled()) {
          return;
        }

        track('asma_product_sticky_add_to_bag');
        submitButton.click();
      });

      root.querySelectorAll('[data-asma-funnel-whatsapp]').forEach((link) => {
        link.addEventListener('click', () => track('asma_product_whatsapp_click'));
      });

      form.addEventListener('change', syncButton);

      const buttonObserver = new MutationObserver(syncButton);
      buttonObserver.observe(submitButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });

      if ('IntersectionObserver' in window) {
        const primaryObserver = new IntersectionObserver(
          (entries) => {
            const primaryButtonVisible = entries[0] ? entries[0].isIntersecting : true;
            syncButton();
            setStickyVisibility(primaryButtonVisible);
          },
          { threshold: 0.15 }
        );

        primaryObserver.observe(form);
      } else {
        syncButton();
        setStickyVisibility(false);
      }

      syncButton();
    };

    const bootAsmaFunnels = () => {
      document.querySelectorAll('[data-asma-funnel]').forEach(initAsmaFunnel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAsmaFunnels, { once: true });
    } else {
      bootAsmaFunnels();
    }

    document.addEventListener('shopify:section:load', bootAsmaFunnels);
  })();
  } catch(e) { console.error(e); }
})();

})();
